const salesChannel = (state = {}, action) => {
  switch (action.type) {
    case "SALES_HISTORY":
      return { ...state, ...action.payload };
    case "REMOVE_SALES_HISTORY":
      return {};
    default:
      return state;
  }
};
export default salesChannel;
